(function () {
  var DEFAULT_KEY = "luxioNeonPromoHidden";
  var DEFAULT_DELAY = 900;
  var AFTER_NEWS_DELAY = 1400;

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function parseDelay(widget) {
    var raw = widget.getAttribute("data-neon-delay");
    var n = parseInt(raw, 10);
    if (isNaN(n) || n < 0) {
      return DEFAULT_DELAY;
    }
    return n;
  }

  function sessionKey(widget) {
    return widget.getAttribute("data-neon-session-key") || DEFAULT_KEY;
  }

  function isSessionHidden(key) {
    try {
      return window.sessionStorage.getItem(key) === "1";
    } catch (err) {
      return false;
    }
  }

  function showWidget(widget) {
    if (isSessionHidden(sessionKey(widget))) return;
    if (document.body.classList.contains("kayer-pl-news-open")) return;
    widget.removeAttribute("hidden");
  }

  function scheduleShow(widget, delay) {
    window.setTimeout(function () {
      showWidget(widget);
    }, delay);
  }

  ready(function () {
    var widget = document.querySelector("[data-neon-promo-widget]");
    if (!widget) {
      return;
    }

    var hasSuccess = !!widget.querySelector("[data-neon-form-success]");
    var key = sessionKey(widget);
    var delay = parseDelay(widget);

    var close = widget.querySelector("[data-neon-promo-close]");
    if (close) {
      close.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        widget.setAttribute("hidden", "hidden");
        try {
          window.sessionStorage.setItem(key, "1");
        } catch (err) {
          /* ignore */
        }
      });
    }

    document.addEventListener("kayer-pl-news:open", function () {
      widget.setAttribute("hidden", "hidden");
    });

    if (hasSuccess) {
      widget.removeAttribute("hidden");
      return;
    }

    if (isSessionHidden(key)) {
      return;
    }

    var deferForNewsletter =
      typeof window.kayerPlNewsletterWantsToShow === "function" &&
      window.kayerPlNewsletterWantsToShow();

    if (deferForNewsletter) {
      document.addEventListener("kayer-pl-news:closed", function onNewsClosed() {
        document.removeEventListener("kayer-pl-news:closed", onNewsClosed);
        scheduleShow(widget, AFTER_NEWS_DELAY);
      });
      return;
    }

    scheduleShow(widget, delay);
  });
})();
